import React, { useContext } from 'react';
import {
  params, useDataModel, extend,
  number as numberType,
  shape as shapeType,
} from '@thd-nucleus/data-sources';
import {
  Card,
  CardBody,
  Typography
} from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ListView } from '@one-thd/sui-icons';
import { AddToContext } from '../../AddToContext';
import { TRACK } from '../../AddToConstants';
import { triggerAnalytics } from '../../AddToHelpers';

export const MODEL_NAME = 'copyListTileVertical';

/**
 * Tile component for copying from existing lists
 */
export const CopyListTileVertical = () => {
  const { setScreen, addToType } = useContext(AddToContext);
  const { data: listsData } = useDataModel('lists', {
    variables: {},
    context: { withAuth: true }
  });
  const isProjectType = addToType === 'Project';
  const minimumListCount = isProjectType ? 0 : 1;
  const isListsTileEnabled = listsData?.lists?.pagination?.totalResults > minimumListCount;
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const handleClick = () => {
    // These is creating a button that does nothing when clicked
    if (isListsTileEnabled) {
      // 10.1 AI Entry Points - Track copy from your lists entry point click
      triggerAnalytics(TRACK.LIST_BUILDER_ENTRY_POINT_CLICK, {
        entryPoint: 'copy from your lists'
      });
      setScreen('COPY_LIST_SUMMARY');
    }
  };

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-label="Copy materials from your existing lists"
      data-testid="copy-list-vertical"
      className="sui-h-full sui-flex sui-gap-2 sui-justify-center sui-items-center sui-cursor-pointer sui-paper-outlined sui-rounded-base sui-p-2"
    >
      <span className="sui-shrink-0 sui-flex sui-items-center">
        <ListView size={isMobile ? 'small' : 'regular'} color={isListsTileEnabled ? 'primary' : 'inactive'} />
      </span>
      <Typography weight="bold" variant={isMobile ? 'body-xs' : 'h6'} color={isListsTileEnabled ? 'primary' : 'inactive'}>
        Copy from your lists
      </Typography>
    </div>
  );
};

CopyListTileVertical.displayName = 'CopyListTileVertical';

CopyListTileVertical.dataModel = extend({
  lists: params({ page: numberType(), pageSize: numberType() }).shape({
    pagination: shapeType({
      totalResults: numberType(),
    })
  })
});

export default CopyListTileVertical;
